// extracted by mini-css-extract-plugin
export default {"wrap":"SecurityChecksPrompt_wrap","iconContainer":"SecurityChecksPrompt_iconContainer","heading":"SecurityChecksPrompt_heading","bodyText":"SecurityChecksPrompt_bodyText"};